import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5E6AD2",
      d: "m.403 37.4 26.198 26.197C13.223 61.336 2.664 50.777.403 37.399M0 30.287 33.713 64a32 32 0 0 0 5.852-.858L.858 24.435c-.46 1.89-.75 3.847-.858 5.852m2.536-10.883 42.06 42.06a32 32 0 0 0 4.4-2.31l-44.15-44.15a32 32 0 0 0-2.31 4.4m5.159-8.259C13.568 4.32 22.268 0 31.977 0 49.663 0 64 14.337 64 32.023c0 9.71-4.32 18.41-11.145 24.282z"
    }, null, -1)
  ]))]))
}
export default { render: render }